import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../services/firebase';
import type { CmsFamilyPtyContent } from '../types/websiteCms.types';
import { DEFAULT_FAMILY_PTY, mergeFamilyPty } from '../data/familyPtyContent';

/** CMS for the unlisted /family-pty lander (websiteContent/familyPty). */
export function useFamilyPtyCms() {
  const [content, setContent] = useState<CmsFamilyPtyContent>(DEFAULT_FAMILY_PTY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const snap = await getDoc(doc(db, 'websiteContent', 'familyPty'));
        if (snap.exists()) setContent(mergeFamilyPty(snap.data() as Partial<CmsFamilyPtyContent>));
      } catch (err) {
        console.warn('[CMS] Failed to load familyPty:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { content, loading };
}
